import { cn } from "@/lib/utils";
import { EUR } from "@/lib/format";

export const StatCard = ({
  label,
  value,
  hint,
  tone = "default",
  testId,
  isCurrency = true,
  onClick,
}) => {
  const tones = {
    default: "border-stone-200",
    positive: "border-emerald-200 bg-emerald-50/40",
    warning: "border-amber-200 bg-amber-50/40",
    negative: "border-rose-200 bg-rose-50/40",
    info: "border-blue-200 bg-blue-50/40",
  };
  const display = isCurrency ? EUR(value) : value;
  const interactive = typeof onClick === "function";
  const Tag = interactive ? "button" : "div";
  return (
    <Tag
      type={interactive ? "button" : undefined}
      onClick={onClick}
      data-testid={testId}
      className={cn(
        "min-w-0 rounded-xl border bg-white px-5 py-4 text-left shadow-[0_1px_0_rgba(15,17,21,0.04)] transition-shadow",
        tones[tone],
        interactive &&
          "cursor-pointer hover:shadow-[0_2px_8px_rgba(15,17,21,0.08)] focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-900/40",
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="text-[11px] font-medium uppercase tracking-wider text-stone-500">
          {label}
        </div>
        {interactive && (
          <span
            aria-hidden
            className="text-[10px] uppercase tracking-wider text-stone-400"
          >
            Dettaglio →
          </span>
        )}
      </div>
      <div
        className="mt-1 truncate font-mono text-2xl font-semibold tabular-nums text-stone-900"
        title={typeof display === "string" ? display : undefined}
      >
        {display}
      </div>
      {hint && <div className="mt-1 text-xs text-stone-500">{hint}</div>}
    </Tag>
  );
};
